export default {
	methods: {
		// axios-api rejects with the server message as a string (e.g. "Your session has expired.").
		toastApiError(error: unknown, fallback: string): void {
			const detail = typeof error === 'string' ? error : fallback;
			(this as any).$toast.add({ severity: 'error', summary: 'Error', detail, life: 6000 });
			if (typeof error !== 'string') console.error(fallback, error);
		},
	},
};
